export default __webpack_public_path__ + "static/media/2023_September_Weg.d7763fb5.webp";